const emotionMap = {'angry':'red','disgustful':'brown','fearful':'purple','happy':'orange','neutral':'grey','sad':'blue','surprised':'green'}

export default emotionMap;